import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, getCurrentInstance } from "vue";
import CloseCircleOutlineIcon from "icons/CloseCircleOutline.vue";
import store from "@/store";
import router from "@/router";
import { useAgentStore } from "@/stores/agent";
import { NolaAnalytics, NolaItemId } from "@/lib/utils/analytics";


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentFeaturePromotionDialog',
  setup(__props) {

const instance = getCurrentInstance();
const agentStore = useAgentStore();
const isSaved = ref(true);
const nolaAnalytics = new NolaAnalytics(instance?.proxy.$gtm!, store);

const closeDialog = () => {
  instance?.proxy.$close(false);
  nolaAnalytics.logButtonEvent(NolaItemId.AgentFeaturePromotionPopupClose);
};

const handleAgentNavigation = () => {
  nolaAnalytics.logButtonEvent(NolaItemId.AgentFeaturePromotionPopupButton);

  // 原稿が保存されている場合は、エージェントイントロ画面に移動する
  if (isSaved.value) {
    router.push({ name: "agent" });
    closeDialog();
    return;
  }

  // 原稿未保存の場合は、isManuscriptUnsavedAgentNavigationフラグを立てて
  // ManuscriptEditor.vueのsave()で原稿保存後にエージェントイントロ画面に移動する
  agentStore.setManuscriptUnsavedAgentNavigation(true);
  closeDialog();
};

onMounted(() => {
  isSaved.value = store.getters["manuscriptModule/isSaved"];
});

return { __sfc: true,instance, agentStore, isSaved, nolaAnalytics, closeDialog, handleAgentNavigation, CloseCircleOutlineIcon }
}

})